import sessionHelper from '../sessionHelper'

export default {
  namespaced: true,
  state: {
    culture: global.dataInit.culture,
    environment: global.dataInit.environment,
    language: global.dataInit.culture.substring(0, 2),
    supportedCultures: global.dataInit.supportedCultures,
    page: '',
    translations: global.dataInit.resources,
    menuOpen: false,
    snackbar: {
      type: '',
      display: 0,
      message: null,
      timeout: null
    },
    showInstallBanner: false
  },
  getters: {
    canShowNewsletter: state => {
      return false
    },
    isProduction: state => {
      return state.environment === 'Production'
    }
  },
  mutations: {
    setPage (state, page) {
      state.page = page
    },

    toggleMenu (state) {
      state.menuOpen = !state.menuOpen
    },

    // permet l'affichage d'un message
    showSnack (state, data) {
      state.snackbar.type = data.type
      state.snackbar.message = data.message
      state.snackbar.timeout = data.timeout
      state.snackbar.display++
    },
    hideSnack (state) {
      state.snackbar.display = 0
    },
    hideInstallBar (state) {
      state.showInstallBanner = false
      sessionHelper.setJsonItem('showInstallBanner', false)
    },
    showInstallBanner (state, prompt) {
      const canShow = sessionHelper.getJsonItem('showInstallBanner')
      if (canShow !== false) {
        state.showInstallBanner = true
      }
    }
  }
}
